module.exports = __webpack_public_path__ + "static/media/dev_app.ddfa4dd2.jpg";